module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_aqua_okunai-9b05811cd8010a7930524bc7eced51d0.jpg";